// SIL-1424. Copy for the purchase-terms consent step shown before a binding
// event (offer deposit, auction bid). The instrument is facts + consent, not
// a second copy of the Exchange User Agreement (see
// docs/superpowers/specs/2026-09-29-exchange-purchase-terms-design.md
// section 2) — this text summarizes what the Agreement already fixes, it
// does not restate fee or risk terms that could drift out of sync with it.
import { ESCROW_AGENT_DISCLOSURE_TEXT, ESCROW_AGENT_ROLE_TEXT } from '@siliconx/shared';

export const PURCHASE_TERMS_HEADING = 'Purchase terms';

export const PURCHASE_TERMS_BODY =
  'Hardware is sold AS IS, WITH ALL FAULTS under the Exchange User Agreement — no inspection window, no buyer protection, no dispute service. Title and risk of loss pass when Escrow.com releases the funds to the seller. The seller arranges and prices shipping and insurance. ' +
  `${ESCROW_AGENT_DISCLOSURE_TEXT} ${ESCROW_AGENT_ROLE_TEXT}`;

export const PURCHASE_TERMS_CHECKBOX_LABEL =
  'I have reviewed the figures above and agree to the purchase terms for this transaction.';

export const PURCHASE_TERMS_CONSENT_ERROR =
  'Your purchase terms consent could not be confirmed in time. Review the terms and try again.';
